// AUTO-GENERATED by scripts/gen-column-maps.ts — do not edit by hand.
// Maps each table's camelCase keys to their DB (snake_case) column names.

export const columnMaps = {
	ai_rec_feedback: {
		id: 'id',
		tenantId: 'tenant_id',
		recId: 'rec_id',
		answer: 'answer',
		adoptedOn: 'adopted_on',
		droppedOn: 'dropped_on',
		answeredBy: 'answered_by',
		answeredAt: 'answered_at',
		updatedAt: 'updated_at',
	},
	api_clients: {
		id: 'id',
		clientId: 'client_id',
		clientSecretHash: 'client_secret_hash',
		nome: 'nome',
		orgId: 'org_id',
		scopes: 'scopes',
		rateLimitPerMinute: 'rate_limit_per_minute',
		tokenTtlSeconds: 'token_ttl_seconds',
		revokedAt: 'revoked_at',
		lastUsedAt: 'last_used_at',
		createdAt: 'created_at',
		updatedAt: 'updated_at',
	},
	api_request_logs: {
		id: 'id',
		apiClientId: 'api_client_id',
		method: 'method',
		path: 'path',
		status: 'status',
		durationMs: 'duration_ms',
		ip: 'ip',
		userAgent: 'user_agent',
		createdAt: 'created_at',
	},
	app_users: {
		id: 'id',
		email: 'email',
		fullName: 'full_name',
		role: 'role',
		createdAt: 'created_at',
		updatedAt: 'updated_at',
	},
	consumption_anomalies: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		kind: 'kind',
		severity: 'severity',
		occurredOn: 'occurred_on',
		lastDay: 'last_day',
		days: 'days',
		value: 'value',
		baseline: 'baseline',
		detectedAt: 'detected_at',
		resolvedAt: 'resolved_at',
		resolution: 'resolution',
		resolvedBy: 'resolved_by',
		note: 'note',
	},
	energy_bill: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		periodFrom: 'period_from',
		periodTo: 'period_to',
		kwhTotale: 'kwh_totale',
		kwhF1: 'kwh_f1',
		kwhF2: 'kwh_f2',
		kwhF3: 'kwh_f3',
		invoiceRef: 'invoice_ref',
		issuedAt: 'issued_at',
		ingestedAt: 'ingested_at',
	},
	energy_bill_readings: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		timestamp: 'timestamp',
		energiaImmessa: 'energia_immessa',
		energiaPrelevata: 'energia_prelevata',
		invoiceRef: 'invoice_ref',
	},
	energy_readings: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		timestamp: 'timestamp',
		energiaImmessa: 'energia_immessa',
		energiaPrelevata: 'energia_prelevata',
		energiaReattiva: 'energia_reattiva',
		source: 'source',
	},
	estimated_data: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		timestamp: 'timestamp',
		energiaImmessa: 'energia_immessa',
		energiaPrelevata: 'energia_prelevata',
		profile: 'profile',
	},
	gse_official_data: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		timestamp: 'timestamp',
		energiaImmessa: 'energia_immessa',
		energiaPrelevata: 'energia_prelevata',
		settlementRef: 'settlement_ref',
	},
	gse_profile_hourly: {
		codice: 'codice',
		mese: 'mese',
		giorno: 'giorno',
		coeff: 'coeff',
	},
	members: {
		id: 'id',
		tenantId: 'tenant_id',
		nome: 'nome',
		tipo: 'tipo',
		ruolo: 'ruolo',
		stato: 'stato',
		dataRecesso: 'data_recesso',
		email: 'email',
		dataIscrizione: 'data_iscrizione',
		invitedAt: 'invited_at',
		userId: 'user_id',
		classificaConsenso: 'classifica_consenso',
		hasStorage: 'has_storage',
		consumptionProfile: 'consumption_profile',
		consumptionProfileData: 'consumption_profile_data',
		dispositivi: 'dispositivi',
		createdAt: 'created_at',
		updatedAt: 'updated_at',
	},
	meteo_fetch_log: {
		id: 'id',
		locationKey: 'location_key',
		tenantId: 'tenant_id',
		source: 'source',
		ok: 'ok',
		attempts: 'attempts',
		variables: 'variables',
		hoursWritten: 'hours_written',
		durationMs: 'duration_ms',
		error: 'error',
		createdAt: 'created_at',
	},
	meteo_hourly: {
		locationKey: 'location_key',
		timestamp: 'timestamp',
		ghi: 'ghi',
		dni: 'dni',
		dhi: 'dhi',
		tAir: 't_air',
		gti: 'gti',
		humidity: 'humidity',
		dewPoint: 'dew_point',
		cloudCover: 'cloud_cover',
		cloudCoverLow: 'cloud_cover_low',
		windSpeed: 'wind_speed',
		windDirection: 'wind_direction',
		windGusts: 'wind_gusts',
		precipitation: 'precipitation',
		snowfall: 'snowfall',
		source: 'source',
		fetchedAt: 'fetched_at',
	},
	meter_api_connections: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		provider: 'provider',
		config: 'config',
		enabled: 'enabled',
		status: 'status',
		state: 'state',
		lastSyncAt: 'last_sync_at',
		lastError: 'last_error',
		createdAt: 'created_at',
		updatedAt: 'updated_at',
	},
	meter_day_curve: {
		meterId: 'meter_id',
		tenantId: 'tenant_id',
		day: 'day',
		layer: 'layer',
		kwh: 'kwh',
		origin: 'origin',
		source: 'source',
		ref: 'ref',
		version: 'version',
		ingestedAt: 'ingested_at',
	},
	meter_live_readings: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		timestamp: 'timestamp',
		obis: 'obis',
		value: 'value',
		simulated: 'simulated',
	},
	meter_slot_buffer: {
		meterId: 'meter_id',
		tenantId: 'tenant_id',
		day: 'day',
		slot: 'slot',
		kwh: 'kwh',
		samples: 'samples',
		updatedAt: 'updated_at',
	},
	meter_typical_profile: {
		meterId: 'meter_id',
		tenantId: 'tenant_id',
		codice: 'codice',
		monthlyKwh: 'monthly_kwh',
		basis: 'basis',
		updatedAt: 'updated_at',
	},
	meters: {
		id: 'id',
		tenantId: 'tenant_id',
		memberId: 'member_id',
		podId: 'pod_id',
		puntoMisura: 'punto_misura',
		kind: 'kind',
		tipo: 'tipo',
		gseProfileCode: 'gse_profile_code',
		verificatoGSE: 'verificato_gse',
		classeCarico: 'classe_carico',
		codiceUP: 'codice_up',
		capacitaKwh: 'capacita_kwh',
		potenzaKw: 'potenza_kw',
		efficienzaCarica: 'efficienza_carica',
		efficienzaScarica: 'efficienza_scarica',
		telemetryMode: 'telemetry_mode',
		gatewayDeviceId: 'gateway_device_id',
		gatewayTokenHash: 'gateway_token_hash',
		gatewayEnabled: 'gateway_enabled',
		gatewayLastSeenAt: 'gateway_last_seen_at',
		gatewayLastError: 'gateway_last_error',
		predictiveEnabled: 'predictive_enabled',
		liveFeedSimulated: 'live_feed_simulated',
		pvgisCache: 'pvgis_cache',
		predictiveCalibration: 'predictive_calibration',
		createdAt: 'created_at',
	},
	mqtt_configurations: {
		id: 'id',
		tenantId: 'tenant_id',
		name: 'name',
		enabled: 'enabled',
		lastReceivedAt: 'last_received_at',
		seenPods: 'seen_pods',
		createdAt: 'created_at',
		updatedAt: 'updated_at',
	},
	notifications: {
		id: 'id',
		tenantId: 'tenant_id',
		memberId: 'member_id',
		direction: 'direction',
		tipo: 'tipo',
		titolo: 'titolo',
		messaggio: 'messaggio',
		letto: 'letto',
		canale: 'canale',
		allegatoPath: 'allegato_path',
		allegatoNome: 'allegato_nome',
		attachments: 'attachments',
		createdAt: 'created_at',
		recipientRole: 'recipient_role',
		requestId: 'request_id',
	},
	organization_branding: {
		organizationId: 'organization_id',
		appName: 'app_name',
		tagline: 'tagline',
		logoUrl: 'logo_url',
		logoDarkUrl: 'logo_dark_url',
		primaryColor: 'primary_color',
		secondaryColor: 'secondary_color',
		fontFamily: 'font_family',
		showSlimsLogoOnLogin: 'show_slims_logo_on_login',
		updatedBy: 'updated_by',
		createdAt: 'created_at',
		updatedAt: 'updated_at',
	},
	organization_features: {
		orgId: 'org_id',
		aiSuggestions: 'ai_suggestions',
		reports: 'reports',
		anomalies: 'anomalies',
		updatedAt: 'updated_at',
	},
	organizations: {
		id: 'id',
		tenantId: 'tenant_id',
		parentId: 'parent_id',
		nome: 'nome',
		codiceGSE: 'codice_gse',
		email: 'email',
		comune: 'comune',
		zonaGeografica: 'zona_geografica',
		lat: 'lat',
		lon: 'lon',
		preEsistentePct: 'pre_esistente_pct',
		pnrrGrantPct: 'pnrr_grant_pct',
		areaConvenzionale: 'area_convenzionale',
		tipoConfigurazione: 'tipo_configurazione',
		cabinaPrimariaCodice: 'cabina_primaria_codice',
		dataAttivazioneGSE: 'data_attivazione_gse',
		disabled: 'disabled',
		demo: 'demo',
		settings: 'settings',
		createdAt: 'created_at',
		updatedAt: 'updated_at',
	},
	plant_anomalies: {
		id: 'id',
		tenantId: 'tenant_id',
		plantId: 'plant_id',
		inverterId: 'inverter_id',
		faultCode: 'fault_code',
		severita: 'severita',
		dettaglio: 'dettaglio',
		valore: 'valore',
		atteso: 'atteso',
		occurredOn: 'occurred_on',
		inverterKey: 'inverter_key',
		rilevatoAt: 'rilevato_at',
		risoltoAt: 'risolto_at',
		risoltoBy: 'risolto_by',
		note: 'note',
	},
	plant_daily_metrics: {
		tenantId: 'tenant_id',
		plantId: 'plant_id',
		giorno: 'giorno',
		energiaKwh: 'energia_kwh',
		pr: 'pr',
		poaWm2: 'poa_wm2',
		tModuliC: 't_moduli_c',
		disponibilita: 'disponibilita',
		updatedAt: 'updated_at',
	},
	plant_fault_types: {
		codice: 'codice',
		categoria: 'categoria',
		severitaDefault: 'severita_default',
		titolo: 'titolo',
		descrizione: 'descrizione',
		soluzione: 'soluzione',
	},
	plant_inverter_daily_metrics: {
		tenantId: 'tenant_id',
		plantId: 'plant_id',
		inverterId: 'inverter_id',
		giorno: 'giorno',
		energiaKwh: 'energia_kwh',
		pr: 'pr',
		updatedAt: 'updated_at',
	},
	plant_inverter_readings: {
		id: 'id',
		tenantId: 'tenant_id',
		inverterId: 'inverter_id',
		timestamp: 'timestamp',
		potenzaAcKw: 'potenza_ac_kw',
		potenzaDcKw: 'potenza_dc_kw',
		energiaKwh: 'energia_kwh',
		temperaturaC: 'temperatura_c',
		simulated: 'simulated',
	},
	plant_inverters: {
		id: 'id',
		tenantId: 'tenant_id',
		plantId: 'plant_id',
		codice: 'codice',
		potenzaKw: 'potenza_kw',
		marca: 'marca',
		modello: 'modello',
		stringheTotali: 'stringhe_totali',
		stato: 'stato',
		ultimoContattoAt: 'ultimo_contatto_at',
		createdAt: 'created_at',
	},
	pods: {
		id: 'id',
		tenantId: 'tenant_id',
		memberId: 'member_id',
		codice: 'codice',
		dso: 'dso',
		cabinaPrimaria: 'cabina_primaria',
		lat: 'lat',
		lon: 'lon',
		tipologiaUtenza: 'tipologia_utenza',
		createdAt: 'created_at',
	},
	production_plants: {
		id: 'id',
		tenantId: 'tenant_id',
		meterId: 'meter_id',
		nome: 'nome',
		localita: 'localita',
		tipo: 'tipo',
		prTarget: 'pr_target',
		censimp: 'censimp',
		codiceGaudi: 'codice_gaudi',
		potenzaKwp: 'potenza_kwp',
		dataEsercizio: 'data_esercizio',
		tecnologia: 'tecnologia',
		dnshConforme: 'dnsh_conforme',
		pnrrGrantPct: 'pnrr_grant_pct',
		areaConvenzionale: 'area_convenzionale',
		quotaMisura: 'quota_misura',
		numeroModuli: 'numero_moduli',
		potenzaModuloW: 'potenza_modulo_w',
		createdAt: 'created_at',
	},
	user_org_memberships: {
		id: 'id',
		userId: 'user_id',
		orgId: 'org_id',
		role: 'role',
		createdAt: 'created_at',
	},
} as const;

export type TableName = keyof typeof columnMaps;
